import toast from "ui/toast";

export default function payDebt(transactionSolution, component) {
	component.saving = true;
	const afterSave = () => {
		component.saving = false
	};
	const book = transactionSolution.book();
	transactionSolution.pay().then(event => {
		toast.cancel(
			component.$formatMessage('transaction_ackCreate'),
			() => book.removeChildren('Transaction', event.created[0].id));
		afterSave();
	}, afterSave);

}



// WEBPACK FOOTER //
// ./src/ui/widgets/pay-debt.js